import styled from 'styled-components'

export const Wrapper = styled.div`
  box-sizing: border-box;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 1rem;
  border: 1px solid #666;
  border-radius: 4px;
  margin: 1rem 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: visible;
`

export const SearchBar = styled.div`
  width: 100%;
  margin-bottom: 0.75rem;

  .ui.input {
    width: 100%;
  }

  .ui.input > input {
    border-radius: 6px;
    border-color: #ccc;
    padding-left: 2.5rem !important;
  }

  .ui.icon.input > i.icon {
    opacity: 0.55;
  }
`

export const LabelEdit = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  width: 100%;
  min-width: 0;
  max-width: 360px;
`

export const LabelEditRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  min-width: 0;

  .ui.input {
    flex: 1 1 auto;
    min-width: 0;
  }

  .ui.input > input {
    border-radius: 6px;
  }
`

export const LabelEditActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex: 0 0 auto;
`

export const LabelEditAction = styled.button<{ $variant?: 'save' | 'cancel' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 6px;
  border: 1px solid
    ${({ $variant }) => ($variant === 'save' ? '#21ba45' : '#ccc')};
  background: ${({ $variant }) => ($variant === 'save' ? '#21ba45' : '#fff')};
  color: ${({ $variant }) => ($variant === 'save' ? '#fff' : '#666')};
  cursor: pointer;

  &:hover {
    filter: brightness(0.96);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const LabelHint = styled.span`
  font-size: 11px;
  color: #999;
  line-height: 1.2;
`

export const FileWrapper = styled.div`
  box-sizing: border-box;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 1.25rem 1rem;
  margin: 0.75rem 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: visible;
  border: 1px solid #666;
  border-radius: 4px;
`

export const InputFile = styled.input`
  display: none;
`

export const FileLine = styled.div`
  display: flex;
  width: 100%;
  max-width: 100%;
  align-items: center;
  gap: 0.75rem;
  padding: 0.35rem 0;
  min-width: 0;
  overflow: visible;
  position: relative;
  z-index: 1;

  /* Mantém o menu do dropdown acima das linhas seguintes da lista */
  &:has(.ui.dropdown.active),
  &:has(.ui.dropdown.visible) {
    z-index: 100;
  }
`

export const FileNameCol = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;

  a {
    color: inherit;
    text-decoration: none;
  }
`

export const FileTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  flex-wrap: nowrap;

  > a {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
  }
`

export const FileTitle = styled.span`
  display: block;
  min-width: 0;
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const FileMeta = styled.span`
  flex: 0 0 auto;
  font-size: 0.9rem;
  color: #666;
  white-space: nowrap;
`

export const FileActions = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 0.25rem;
`

export const Icon = styled.div`
  width: 2rem;
  flex: 0 0 auto;
  cursor: pointer;
  padding: 0 2px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const AddFileArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const InputButton = styled.input`
  margin-top: 2rem;
  font-size: 1rem;
  padding: 0.8rem 1.2rem;
  background-color: #666;
  border-radius: 4px;
  color: white;
  border: 1px solid transparent;
  cursor: pointer;
  &:hover {
    background-color: white;
    color: #666;
    border: 1px solid #666;
  }
`

export const Select = styled.select`
  background-position: center right;
  background-repeat: no-repeat;
  border: 1px solid #aaa;
  border-radius: 2px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  color: #555;
  font-size: inherit;
  margin: 0;
  overflow: hidden;
  padding-top: 2px;
  padding-bottom: 2px;
  text-overflow: ellipsis;
  white-space: nowrap;
  outline: none;
  flex: 0 1 180px;
  width: 180px;
  min-width: 120px;
  max-width: 100%;
`

export const SelectDiv = styled.div`
  flex: 0 1 180px;
  width: 180px;
  min-width: 120px;
  max-width: 100%;
  position: relative;

  .ui.dropdown {
    width: 100%;
  }

  .ui.dropdown .menu {
    z-index: 1000;
  }
`

export const LabelSavedFiles = styled.p`
  width: 100%;
  text-align: left;
  margin: 0 0 0.75rem;
`

export const TagSavedFiles = styled.p`
  width: 100%;
  text-align: center;
  font-weight: 500;
`
